/**
 * Format an ISO datetime string to a locale time string (HH:MM, 24h, en-GB)
 */
export function formatSlotTime(isoString, timeZone) {
    try {
        return new Date(isoString).toLocaleTimeString('en-GB', {
            hour: '2-digit', minute: '2-digit', hour12: false, ...(timeZone ? { timeZone } : {}),
        });
    } catch {
        return isoString;
    }
}

/**
 * Format an ISO datetime string to a human-readable date+time label
 * e.g. "Wed, 15 Jan · 09:00"
 */
export function formatSlotLabel(isoString, timeZone) {
    if (!isoString) return '';
    try {
        const date = new Date(isoString);
        const day = date.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', ...(timeZone ? { timeZone } : {}) });
        const time = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false, ...(timeZone ? { timeZone } : {}) });
        return `${day} · ${time}`;
    } catch {
        return isoString;
    }
}

/**
 * Calculate the end time by adding durationMinutes to a start ISO string.
 * Returns an HH:MM string or null if input is invalid.
 */
export function calcEndTime(startIso, durationMinutes, timeZone) {
    try {
        const d = new Date(new Date(startIso).getTime() + durationMinutes * 60000);
        return d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false, ...(timeZone ? { timeZone } : {}) });
    } catch {
        return null;
    }
}

/**
 * Format a local Date object to YYYY-MM-DD without timezone offset issues.
 */
export function formatLocalDate(date) {
    if (!date) return '';
    return [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0'),
    ].join('-');
}
